module.exports = __webpack_public_path__ + "img/ios_qr.c13110e9.png";